import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightBig = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "white",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24.9375 15L40 30.0625L24.9375 45.125L22.25 42.4375L34.625 30.0625L22.25 17.6875L24.9375 15Z" })
});
export default SvgArrowRightBig;
